<template lang="pug">
el-dialog.modal-analise-elegibilidade-Ar(
    :visible.sync='show',
    width='80%',
    :before-close='handleCloseModal',
    :close-on-click-modal='false',
    :fullscreen='false',
    append-to-body,
    destroy-on-close
)
    span(slot='title')
        .modal-analise-elegibilidade--header.mr-1
            h3 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analiseDeElegibilidade') }}
            .analise-elegibilidade--header__status
                div(
                    :class='statusElegibilidade[dados.codigoStatusElegibilidade] ? statusElegibilidade[dados.codigoStatusElegibilidade].classeCor : ""'
                )
                    i.mdi.mdi-check-circle(
                        v-if='dados.codigoStatusElegibilidade === "ELEGIVEL"'
                    )
                    i.mdi.mdi-information.font-size-mdi(
                        v-else-if='dados.codigoStatusElegibilidade === "ALERTA"'
                    )
                    i.flow.flow-warning-sign(
                        v-else-if='dados.codigoStatusElegibilidade === "INELEGIVEL"'
                    )
            h4.status-elegibilidade(
                :class='statusElegibilidade[dados.codigoStatusElegibilidade] ? statusElegibilidade[dados.codigoStatusElegibilidade].classeCor : ""'
            ) {{ getStatusElegibilidadeFormatado(dados.codigoStatusElegibilidade) }}

    .modal-analise-elegibilidade--body
        .direita.lista-scroll
            .modal-analise-elegibilidade--sub-title
                i.mdi.mdi-check-circle(
                    v-if='classeDiagnosticoCar === "BAIXO"',
                    :class='statusDiagnostico[classeDiagnosticoCar].corClasse'
                )
                i.mdi.mdi-information.font-size-mdi(
                    v-else-if='classeDiagnosticoCar === "MEDIO" || classeDiagnosticoCar === "MEDIO_ALTO"',
                    :class='statusDiagnostico[classeDiagnosticoCar].corClasse'
                )
                i.flow.flow-warning-sign.mr-1(
                    v-else,
                    :class='statusDiagnostico[classeDiagnosticoCar].corClasse'
                )
                h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.diagnosticoSocioambiental') }}
            .modal-analise-bloco
                .modal-analise-bloco--title
                    .modal-analise-bloco--title--car
                        span RENSPA:
                    .modal-analise-bloco--title--descricao
                        span
                        |
                        | {{ this.mascaraRenspa(dados.renspaTerritorio) }}
                hr
                .modal-analise-bloco-lista-scroll
                    el-collapse(
                        v-model='collapseAtivo',
                        @change='exibirRestricoesNoMapa',
                        accordion
                    )
                        el-collapse-item(
                            v-for='(diagnostico, index) in dados.resumoDiagnosticoTerritorio?.diagnostico',
                            v-if='diagnostico.nivelAlerta !== "BAIXO"',
                            :key='index',
                            :name='index'
                        )
                            template(slot='title')
                                i.mr-2.flow.flow-warning-sign.mr8.custon-icon-collapse--menor(
                                    v-if='diagnostico.nivelAlerta === "ALTO"',
                                    :class='statusDiagnostico[diagnostico.nivelAlerta].corClasse'
                                )
                                i.mdi.mdi-information.font-size-mdi.mr8.custon-icon-collapse--menor(
                                    v-else='classeDiagnosticoCar === "MEDIO" || classeDiagnosticoCar === "MEDIO_ALTO"',
                                    :class='statusDiagnostico[diagnostico.nivelAlerta].corClasse'
                                )
                                span
                                | {{ diagnostico.camada.nome }}

                                div(v-if='diagnostico.resultados.length')
                                    el-tag.custon-tag(
                                        size='mini',
                                        type='danger'
                                    ) {{ diagnostico.resultados.length }}

                            div(
                                v-if='diagnostico && diagnostico.resultados.length'
                            )
                                component(
                                    ref='componente',
                                    v-bind:is='prepararComponente(diagnostico)',
                                    v-bind='prepararDadosParaComponente(diagnostico)',
                                    @aplicar-zoom-restricao='aplicarZoomRestricao'
                                )

                            .container-sem-restricoes(
                                v-if='diagnostico.resultados.length === 0'
                            )
                                p {{ $t('mensagens.relatorioRastreabilidade.cadastro.naoHaRestricoes') }}

                            Fonte(
                                :fonte='diagnostico?.camada?.fonte ? diagnostico.camada.fonte : {}'
                            )

                    p(
                        v-if='classeDiagnosticoCar === "BAIXO"',
                        :class='statusDiagnostico[classeDiagnosticoCar].corClasse'
                    ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.nenhumaConformidade') }}

                hr

            .modal-analise-bloco-bloco--title
                i.mdi.mdi-check-circle.status-sucess(v-if='raioPermitido()')
                i.flow.flow-warning-sign.mr-1.status-danger(v-else)
                h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.distancia') }}
            .modal-analise-bloco
                .bloco-distancia
                    p.bloco-distancia--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaImovelAoMunicipio') }} {{ buscarDistanciaRaioLocalidade() }} km
                    el-alert(
                        v-if='this.getLimiteRaio()',
                        :title='getTitleDistanciaImovel()',
                        :type='raioPermitido() ? "success" : "error"',
                        show-icon,
                        :closable='false'
                    )
            .bloco-capacidade-produtiva--sub-title
                i.mdi.mdi-check-circle.status-sucess
                h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdutivaArea') }}
            .modal-analise-bloco
                .bloco-capacidade-produtiva--conteudo
                    span.bloco-capacidade-produtiva--conteudo--interno
                        .bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.area') }}
                        | {{ this.formatNumber(saldoAr.areaHa) ?? '---' }} ha

                    .bloco-capacidade-produtiva--conteudo-baixo
                        .bloco-capacidade-produtiva--conteudo-baixo--interno
                            el-tooltip(
                                placement='top',
                                :content='`${$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.fonte")}: ${$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.ministerioAr")}`'
                            )
                                span
                                    i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                    span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.produtividade') }}
                            | {{ this.formatNumber(saldoAr.rendimento) ?? '---' }} t/ha

                hr

                .bloco-capacidade-produtiva--conteudo-baixo
                    span.bloco-capacidade-produtiva--conteudo--interno
                        el-tooltip(
                            placement='top',
                            :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdXAreaConsolidada")'
                        )
                            span
                                i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdutiva') }}
                        | {{ formatNumber(saldoAr.capacidadeProdutiva) }} t

                        span.bloco-capacidade-produtiva--conteudo--interno
                        el-tooltip(
                            placement='top',
                            :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.valorUtilizadoCapacidade")'
                        )
                            span
                                i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.saldoComprometido') }}
                        span.status-danger {{ formatNumber(saldoAr.saldoConsumidoCapacidadeProdutiva) }} t

                    span.bloco-capacidade-produtiva--conteudo--interno
                        el-tooltip(
                            placement='top',
                            :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.valordisponivelCapacidade")'
                        )
                            span
                                i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.saldoDisponivel') }}
                        span.status-sucess {{ formatNumber(saldoAr.saldoCapacidadeProdutiva) }} t

        .esquerda
            .mapa-elegibilidade
                Mapa(
                    ref='mapaAr',
                    :mapLayersConfigs='layersMaps',
                    :mapConfig='mapConfig',
                    :height='"93%"',
                    :idMapa='"mapaAnaliseElegibilidadeAr"'
                )

    span(slot='footer')
        el-button(type='primary', @click='handleCloseModal') {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.voltar') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import Fonte from '@/components/diagnosticoSocioambiental/Fonte.vue';
import ApriaReservaDeLaBiosfera from '@/components/diagnosticoSocioambiental/ApriaReservaDeLaBiosfera.vue';
import ReservaProvinciale from '@/components/diagnosticoSocioambiental/ReservaProvinciale.vue';
import DesmatamentoInfonaParaguai from '@/components/diagnosticoSocioambiental/DesmatamentoInfonaParaguai.vue';
import OtbnArgentina from '../diagnosticoSocioambiental/OtbnArgentina.vue';
import AppArgentinaPontos from '../diagnosticoSocioambiental/AppArgentinaPontos.vue';
import AppArgentinaPoligonos from '../diagnosticoSocioambiental/AppArgentinaPoligonos.vue';
import ApnSifap from '../diagnosticoSocioambiental/ApnSifap.vue';
import ApriaPatrimonioDaHumanidadPuntos from '../diagnosticoSocioambiental/ApriaPatrimonioDaHumanidadPuntos.vue';
import ApriaSitiosRamsar from '../diagnosticoSocioambiental/ApriaSitiosRamsar.vue';
import DesmatamentoArgentina from '../diagnosticoSocioambiental/DesmatamentoArgentina.vue';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';

const restricaoPattern =
    'https://lyra-bunge-publico.s3.amazonaws.com/restricao_pattern.gif';

export default {
    name: 'ModalAnaliseElegibilidadeAr',
    components: {
        Mapa,
        Fonte,
        ApriaReservaDeLaBiosfera,
        ReservaProvinciale,
        DesmatamentoInfonaParaguai,
        OtbnArgentina,
        AppArgentinaPontos,
        AppArgentinaPoligonos,
        ApnSifap,
        ApriaPatrimonioDaHumanidadPuntos,
        ApriaSitiosRamsar,
        DesmatamentoArgentina
    },
    emits: ['handleCloseModalAnaliseElegibidade'],
    props: {
        show: {
            type: Boolean
        },
        dados: {
            type: Object
        },
        saldoAr: {
            type: Object
        },
        dadosCalculoRaioAr: {
            type: Object
        }
    },
    data() {
        return {
            distanciaDentroDoLimite: this.$t(
                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaDentroDoLimite'
            ),
            distanciaExcedidaDoLimite: this.$t(
                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaExcedidaDoLimite'
            ),
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                },
                inspecionar: false,
                diagnostico: false
            },
            collapseAtivo: '',
            collapseAtivoPessoa: '',
            refMapa: null,
            carregandoProdutividade: false,
            dadosProdutividade: {
                estado: {
                    nome: ''
                },
                area: null,
                areaUnidadeMedida: '',
                produtividade: null,
                produtividadeUnidadeMedida: '',
                capacidadeProdutiva: null,
                capacidadeProdutivaUnidadeMedida: '',
                calculoSaca: {
                    mediaRegional: null,
                    produtividade: null
                },
                fatorProdutividade: null,
                fonteDados: {
                    id: null,
                    nome: '',
                    sigla: ''
                }
            },
            classeDiagnosticoCar: 'INDEFINIDO',
            classeDiagnostcoRepresentante: '',
            restricaoRepresentante: [],
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: 'Alerta'
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: 'Alerta'
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: 'Conforme'
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: 'Inconforme'
                },
                INDEFINIDO: {
                    corClasse: '',
                    status: ''
                }
            },
            statusElegibilidade: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    )
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inelegivel'
                    )
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: ''
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.comAlerta'
                    )
                },
                EM_PROCESSAMENTO: {
                    classeCor: 'status-cinza',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.laudoEmProcessamento'
                    )
                }
            },
            representantesElegiveis: [],
            representantesInelegiveis: [],
            dadosRaioLocalidade: {}
        };
    },
    computed: {},
    watch: {
        show: function () {
            if (!this.show) return;
            this.mostrarTerritorioNoMapa();
            this.definirStatusTerritorio();
            this.definirStatusRepresentante();
            this.separarNivelRepresentante();
            this.preencherDadosRaio();
        }
    },
    methods: {
        handleCloseModal() {
            this.$emit('handleCloseModalAnaliseElegibidade');
        },
        mostrarTerritorioNoMapa() {
            this.refMapa = this.$refs['mapaAr'];

            this.layersMaps = [];
            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território analisado',
                geoJson: this.dados.geometriaTerritorio
            };

            this.layersMaps.push(layerTerritorio);
        },
        aplicarZoomRestricao(
            restricao,
            geometriaQueNaoEstavaDentroDasRestricoes,
            index
        ) {
            let geoJson =
                restricao.geometry ||
                restricao.geometria ||
                restricao.properties?.geometry ||
                restricao.properties?.geometria ||
                restricao.propriedade?.geometry ||
                restricao.propriedade?.geometria ||
                geometriaQueNaoEstavaDentroDasRestricoes;

            if (
                !geoJson &&
                restricao.properties?.latitude &&
                restricao.properties?.longitude
            ) {
                geoJson = {
                    type: 'Point',
                    coordinates: [
                        restricao.properties.longitude,
                        restricao.properties.latitude
                    ]
                };
            }
            this.refMapa = this.$refs['mapaAr'];

            this.refMapa.aplicarZoomGeoJson(geoJson);
        },
        prepararComponente(diagnostico) {
            if (!diagnostico.camada.codigo) return;

            const partes = diagnostico.camada.codigo.split('_');
            const resultado = partes.map(parte => {
                return (
                    parte.charAt(0).toUpperCase() + parte.slice(1).toLowerCase()
                );
            });
            return resultado.join('');
        },
        prepararDadosParaComponente(diagnostico) {
            const geometrias = [];
            diagnostico.resultados.forEach(geom => {
                geometrias.push(geom.geometry);
            });
            return {
                restricoes: diagnostico.resultados,
                geometria: geometrias,
                habilitarZoomRestricao: true
            };
        },
        removerRestricoesNoMapa() {
            this.layersMaps = this.layersMaps.filter(
                layer => layer.name === `Território analisado`
            );
        },
        definirStatusRepresentante() {
            this.restricaoRepresentante = [];
            if (this.dados.resumoDiagnosticoRepresentantes.length) {
                this.dados.resumoDiagnosticoRepresentantes.forEach(
                    (item, indice) => {
                        this.restricaoRepresentante[indice] = false;

                        if (item?.diagnostico.length) {
                            item.diagnostico.forEach(e => {
                                if (e.nivelAlerta !== 'BAIXO') {
                                    this.restricaoRepresentante[indice] = true;
                                }
                            });
                        }
                    }
                );
            }
        },
        definirStatusTerritorio() {
            this.classeDiagnosticoCar = 'INDEFINIDO';
            let laranja = false;
            let vermelho = false;
            let amarelo = false;
            if (this.dados.resumoDiagnosticoTerritorio?.diagnostico.length) {
                this.dados.resumoDiagnosticoTerritorio.diagnostico.forEach(
                    diagnostico => {
                        if (diagnostico.nivelAlerta === 'ALTO') {
                            vermelho = true;
                        }
                        if (diagnostico.nivelAlerta === 'MEDIO') {
                            amarelo = true;
                        }
                        if (diagnostico.nivelAlerta === 'MEDIO_ALTO') {
                            laranja = true;
                        }
                    }
                );
            }
            if (vermelho) {
                this.classeDiagnosticoCar = 'ALTO';
            } else if (laranja) {
                this.classeDiagnosticoCar = 'MEDIO_ALTO';
            } else if (amarelo) {
                this.classeDiagnosticoCar = 'MEDIO';
            } else {
                this.classeDiagnosticoCar = 'BAIXO';
            }
        },

        formatNumber(number) {
            const numericValue = parseFloat(number);
            return Number.isInteger(numericValue)
                ? numericValue.toString()
                : numericValue.toFixed(3);
        },

        exibirRestricoesNoMapa() {
            this.removerRestricoesNoMapa();
            if (
                typeof this.collapseAtivo === 'string' &&
                this.collapseAtivo === ''
            ) {
                return;
            }

            const areas = this.dados.resumoDiagnosticoTerritorio?.diagnostico[
                this.collapseAtivo
            ].resultados.filter(
                resultado =>
                    resultado.geometria ||
                    resultado.geometry ||
                    (resultado.properties.latitude &&
                        resultado.properties.longitude)
            );

            const opacidade = 0.5;

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                if (geometria) {
                    const name = `AreaDiagnostico-${this.collapseAtivo}-${index}`;
                    if (!this.layersMaps.find(layer => layer.name === name)) {
                        this.layersMaps.push({
                            name,
                            indexDiagnostico: this.collapseAtivo,
                            group: `grupo-restricoes-${this.collapseAtivo}`,
                            style: {
                                color: '#c20a0a',
                                weight: 1,
                                fill: 'url(' + restricaoPattern + ')',
                                opacity: opacidade,
                                fillOpacity: opacidade
                            },
                            geoJson: geometria
                        });
                    }

                    let icon = null;

                    if (geometria.type !== 'Point') {
                        icon = L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });
                        const nameCentroid = `CentroidDiagnostico-${this.collapseAtivo}-${index}`;
                        if (
                            !this.layersMaps.find(
                                layer => layer.name === nameCentroid
                            )
                        ) {
                            this.layersMaps.push({
                                name: nameCentroid,
                                group: `grupo-centroid-${this.collapseAtivo}`,
                                indexDiagnostico: this.collapseAtivo,
                                icon,
                                geoJson: centroidFromGeoJSON.get(geometria)
                            });
                        }
                    }
                } else {
                    const { properties } = area;
                    if (
                        properties &&
                        properties.latitude &&
                        properties.longitude
                    ) {
                        const name = `AreaDiagnostico-${this.collapseAtivo}-${index}`;
                        if (
                            !this.layersMaps.find(layer => layer.name === name)
                        ) {
                            this.layersMaps.push({
                                name,
                                indexDiagnostico: this.collapseAtivo,
                                group: `grupo-restricoes-${this.collapseAtivo}`,
                                style: {
                                    color: '#c20a0a',
                                    weight: 10,
                                    fill: 'url(' + restricaoPattern + ')',
                                    opacity: 0.5,
                                    fillOpacity: opacidade
                                },
                                geoJson: {
                                    type: 'Point',
                                    coordinates: [
                                        properties.longitude,
                                        properties.latitude
                                    ]
                                }
                            });
                        }
                    }
                }
            });
        },
        exibirRestricoesRepresentantesNoMapa() {
            this.removerRestricoesNoMapa();
            if (
                typeof this.collapseAtivoPessoa === 'string' &&
                this.collapseAtivoPessoa === ''
            ) {
                return;
            }

            const collapseRepresentantes = this.$refs?.collapseRepresentantes;
            const collapseAberto = collapseRepresentantes?.$children?.find(
                child => child._uid === this.collapseAtivoPessoa
            );
            const diagnostico =
                this.representantesInelegiveis[collapseAberto?.$attrs?.index];

            const areas = diagnostico?.dados[0]?.resultados.filter(
                resultado =>
                    resultado.geometria ||
                    resultado.geometry ||
                    (resultado.properties.latitude &&
                        resultado.properties.longitude)
            );

            const opacidade = 0.5;

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                if (geometria) {
                    const name = `AreaDiagnosticoRepresentante-${this.collapseAtivo}-${index}`;
                    if (!this.layersMaps.find(layer => layer.name === name)) {
                        this.layersMaps.push({
                            name,
                            indexDiagnostico: this.collapseAtivoPessoa,
                            group: `grupo-restricoes-representante-${this.collapseAtivoPessoa}`,
                            style: {
                                color: '#c20a0a',
                                weight: 1,
                                fill: 'url(' + restricaoPattern + ')',
                                opacity: opacidade,
                                fillOpacity: opacidade
                            },
                            geoJson: geometria
                        });
                    }

                    let icon = null;

                    if (geometria.type !== 'Point') {
                        icon = L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });
                        const nameCentroid = `CentroidDiagnosticoRepresentante-${this.collapseAtivoPessoa}-${index}`;
                        if (
                            !this.layersMaps.find(
                                layer => layer.name === nameCentroid
                            )
                        ) {
                            this.layersMaps.push({
                                name: nameCentroid,
                                group: `grupo-centroid-representante-${this.collapseAtivoPessoa}`,
                                indexDiagnostico: this.collapseAtivoPessoa,
                                icon,
                                geoJson: centroidFromGeoJSON.get(geometria)
                            });
                        }
                    }
                } else {
                    const { properties } = area;
                    if (
                        properties &&
                        properties.latitude &&
                        properties.longitude
                    ) {
                        const name = `AreaDiagnosticoRepresentante-${this.collapseAtivoPessoa}-${index}`;
                        if (
                            !this.layersMaps.find(layer => layer.name === name)
                        ) {
                            this.layersMaps.push({
                                name,
                                indexDiagnostico: this.collapseAtivo,
                                group: `grupo-restricoes-representante-${this.collapseAtivoPessoa}`,
                                style: {
                                    color: '#c20a0a',
                                    weight: 10,
                                    fill: 'url(' + restricaoPattern + ')',
                                    opacity: 0.5,
                                    fillOpacity: opacidade
                                },
                                geoJson: {
                                    type: 'Point',
                                    coordinates: [
                                        properties.longitude,
                                        properties.latitude
                                    ]
                                }
                            });
                        }
                    }
                }
            });
        },
        separarNivelRepresentante() {
            this.representantesInelegiveis = [];
            this.representantesElegiveis = [];
            if (!this.dados.resumoDiagnosticoRepresentantes) {
                return;
            }
            this.dados.resumoDiagnosticoRepresentantes.forEach(
                representante => {
                    if (representante?.diagnostico.length) {
                        if (
                            representante?.diagnostico.some(
                                diagnostico =>
                                    diagnostico.nivelAlerta !== 'BAIXO'
                            )
                        ) {
                            if (representante?.diagnostico) {
                                representante.diagnostico.forEach(
                                    diagnostico => {
                                        if (
                                            diagnostico.nivelAlerta !== 'BAIXO'
                                        ) {
                                            if (
                                                !this.representantesInelegiveis[
                                                    diagnostico.camada.codigo
                                                ]
                                            ) {
                                                this.representantesInelegiveis[
                                                    diagnostico.camada.codigo
                                                ] = [];
                                            }
                                            this.representantesInelegiveis[
                                                diagnostico.camada.codigo
                                            ].push(diagnostico);
                                        }
                                    }
                                );
                            }
                        } else {
                            this.representantesElegiveis.push(
                                representante.cpfCnpj
                            );
                        }
                    }
                }
            );

            let alertaInelegivel = [];
            for (let tipo in this.representantesInelegiveis) {
                if (
                    Object.prototype.hasOwnProperty.call(
                        this.representantesInelegiveis,
                        tipo
                    )
                ) {
                    alertaInelegivel.push({
                        dados: [...this.representantesInelegiveis[tipo]]
                    });
                }
            }

            this.representantesInelegiveis = [...alertaInelegivel];
        },
        preencherDadosRaio() {
            this.dadosRaioLocalidade = this.dadosCalculoRaioAr;
        },
        raioPermitido() {
            return (
                this.dadosRaioLocalidade.distanciaRaioLocalidade <=
                this.dadosRaioLocalidade.distanciaPermitida
            );
        },
        getTitleDistanciaImovel() {
            return this.raioPermitido()
                ? this.distanciaDentroDoLimite
                : this.distanciaExcedidaDoLimite +
                      `${this.getLimiteRaio()} km.`;
        },

        getLimiteRaio() {
            return this.dadosRaioLocalidade.distanciaPermitida;
        },
        buscarDistanciaRaioLocalidade() {
            return this.dadosRaioLocalidade.distanciaRaioLocalidade;
        },
        mascaraRenspa(renspa) {
            if (renspa === null || typeof renspa === 'undefined') {
                return ''; // Ou qualquer outro valor padrão que faça sentido (ex: 'N/A')
            }
            let formattedValue = String(renspa);
            const apenasNumeros = formattedValue.replace(/\D/g, '');

            const formato = apenasNumeros.replace(
                /^(\d{2})(\d{3})(\d{1})(\d{5})(\d{2})$/,
                '$1.$2.$3.$4/$5'
            );

            return formato;
        },
        getStatusElegibilidadeFormatado(status) {
            switch (status) {
                case 'ELEGIVEL':
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    );
                case 'INELEGIVEL':
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inelegivel'
                    );
                case 'ALERTA':
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.comAlerta'
                    );
                default:
                    return '';
            }
        }
    }
};
</script>
<style lang="scss">
.modal-analise-elegibilidade-Ar {
    .status-amarelo {
        color: #bfae19;
        font-weight: 600;
    }

    .status-laranja {
        color: var(--warning);
        font-weight: 600;
    }

    .status-danger {
        color: var(--danger);
        font-weight: 600;
    }

    .status-sucess {
        color: var(--green);
        font-weight: 600;
    }

    .status-cinza {
        color: #6d6a6a;
        font-weight: 600;
    }

    p .status-sucess {
        margin-bottom: 0px;
    }

    .el-dialog__body {
        padding: 14px 15px;
        height: 515px;
    }

    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: #f6f6f6;
        color: #3b3b3b;
        padding-bottom: 12px;
        padding-top: 12px;
    }

    .el-dialog__headerbtn {
        top: 10px;
    }

    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }

    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
        height: 30px;

        .analise-elegibilidade--header__status {
            margin-left: 4px;
            display: flex;
            align-items: center;
        }

        .status-elegibilidade {
            margin-left: 2px;
        }
    }

    .direita-sub-title {
        font-weight: bold;
        color: #3b3b3b;
        font-size: 15px;
        margin-bottom: 8px;
        margin-top: 8px;
    }

    .modal-analise-elegibilidade--sub-title,
    .bloco-capacidade-produtiva--sub-title {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .modal-analise-elegibilidade--body {
        height: 495px;
        display: flex;
        justify-content: space-between;
        gap: 1%;

        .direita.lista-scroll {
            width: 52%;
            max-height: 495px;
            overflow: auto;
        }

        .esquerda {
            width: 47%;

            .mapa-elegibilidade {
                height: 100%;
                min-height: 568px;
                border-radius: 4px;
                overflow: hidden;
                margin: 0px 0 9px 0;
            }

            .bloco-distancia {
                min-height: 116px;
            }
        }

        .modal-analise-bloco-lista-scroll {
            overflow-y: auto;
            max-height: 230px;
            padding: 5px 0px;
        }

        .modal-analise-bloco-bloco--title {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .modal-analise-bloco {
            background: #f7f6f6;
            border-radius: 5px;
            padding: 12px 11px;

            &.modal-analise-bloco__baixo {
                margin-top: 9px !important;
            }

            .modal-analise-bloco-cpf-cnpj {
                .titulo {
                    color: #183b57;
                    font-weight: bold;
                    margin-right: 5px;
                }
            }

            .modal-analise-bloco--title {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #3b3b3b;
                margin-bottom: 13px;
                gap: 4px;
            }

            .container-sem-restricoes {
                p {
                    margin-left: 20px;
                }
            }

            .modal-analise-bloco--conteudo,
            .bloco-capacidade-produtiva--conteudo {
                display: flex;
                gap: 20px;
                justify-content: flex-start;
                flex-wrap: wrap;
            }

            .bloco-capacidade-produtiva--conteudo--interno,
            .bloco-capacidade-produtiva--conteudo--interno {
                margin-bottom: 5px;
                display: flex;
                flex-direction: column;
            }

            .modal-analise-bloco--conteudo--interno--title,
            .bloco-capacidade-produtiva--conteudo--title,
            .bloco-distancia--conteudo--title,
            .modal-analise-bloco--title--car {
                color: #183b57;
                font-weight: bold;
            }

            .bloco-capacidade-produtiva--conteudo-baixo {
                display: flex;
                justify-content: flex-start;
                gap: 20px;
                flex-wrap: wrap;

                .bloco-capacidade-produtiva--conteudo-baixo--interno {
                    display: flex;
                    flex-direction: column;
                }
            }
        }

        .el-collapse-item__header {
            background-color: #f7f6f6;
            color: #3b3b3b;
        }

        .el-collapse-item__content {
            background: #f7f6f6;
        }

        .custon-icon-collapse--grande {
            font-size: 18px;
        }

        .custon-icon-collapse--menor {
            font-size: 13px;
        }
    }

    .el-dialog.is-fullscreen {
        .modal-analise-bloco-lista-scroll {
            max-height: 550px !important;
        }
    }

    .modal-anotacao-footer {
        display: flex;
        justify-content: space-between;
    }

    .el-alert__title {
        color: #3b3b3b;
        font-weight: bold;
    }

    i.custon-icon-collapse--menor {
        margin-right: 4px;
    }

    .lista-scroll::-webkit-scrollbar-thumb {
        background: var(--primary);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    i {
        font-weight: 600;
    }

    .modal-analise-elegibilidade
        .modal-analise-elegibilidade--body
        .modal-analise-bloco
        .modal-analise-bloco-cpf-cnpj
        span {
        margin-right: 0px;
    }

    hr {
        margin-top: 0rem;
        margin-bottom: 0rem;
        border: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    .el-collapse-item__header {
        height: 35px !important;
        border: 0 !important;
        line-height: initial !important;
        padding: 0px 0px;
    }
}
</style>
